import React, { useState, useEffect } from "react";
import Slider from "react-slick";
const images = require.context("../assets/images", false);


function Testimonials() {
const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const updateSlides = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setSlidesToShow(1);
      } else if (width < 992) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    updateSlides(); // run immediately

    window.addEventListener("resize", updateSlides);
    return () => window.removeEventListener("resize", updateSlides);
  }, []);


  const [activeSlide, setActiveSlide] = useState(0);

  // Custom Next Arrow
  const NextArrow = ({ onClick }) => (
    <button className="custom-next next2 slick-arrow" onClick={onClick}>
      <img src={images("./Forward.svg")} alt="next arrow" />
    </button>
  );

  // Custom Prev Arrow
  const PrevArrow = ({ onClick }) => (
    <button className="custom-prev prev2 slick-arrow" onClick={onClick}>
      <img src={images("./backward.svg")} alt="prev arrow" />
    </button>
  );

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "0px",
    autoplay: true,           // ✅ AUTO SLIDE
    autoplaySpeed: 30000,      // 3 seconds
    speed: 600,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    beforeChange: (oldIndex, newIndex) => {
      setActiveSlide(newIndex);
    }
  };

  const testimonials = [
    { name: "Radhika Sharma", role: "Patient" },
    { name: "Amit Verma", role: "Patient" },
    { name: "Sneha Gupta", role: "Patient" },
    { name: "Amit Verma", role: "Patient" }
  ];
const testimonials456 = [
  {
    name: "anna belhassen",
    role: "Patient",
    image: images("./anna.png"),
    description: "Fantastic experience! Everything was so well organise and made super easy and comfortable for us. We got to see such a varied tour of India, a truly unforgettable experience. I definitely recommend!"
  },
  {
    name: "Faydker Sebastian Bejarano",
    role: "Local Guide",
    image: images("./Faydker.png"),
    description: "Great tour!!! It went beyond my expectations! We did Delhi, Agra and Jaipur tour"
  },
  {
    name: "Maria Claudia Vidal",
    role: "Patient",
    image: images("./maria.png"),
    description: "My husband and I took the Golden Triangule Tour and we visited Delhi, Agra and Jaipur! All was fantastic… our guides in each city… the schedule for each place… we really appreciate this time ..."
  },
  {
    name: "Amar D",
    role: "Patient",
    image: images("./anna.png"),
    description: "We had a wonderful and memorable experience of Golden Triangle Tour last month arranged by Luxury Golden Triangle Tour India, while visiting from US.  They took care of making arrangements ..."
  },
  {
    name: "Thomas Rapp",
    role: "Local Guide",
    image: images("./Faydker.png"),
    description: "We booked a 15-day tour through Rajasthan and Uttar Pradesh with this tour operator. We found them through a web search and requested a quote. To compare their offer, we also obtained quotes ..."
  },
  {
    name: "Charlotte",
    role: "Patient",
    image: images("./Charlotte.png"),
    description: "Thank you so much for the wonderful trip you organized for us. We spent 15 days in Rajasthan and Varanasi, India, with Luxury Golden Triangle Tour. The booking process was very professional ..."
  },
  {
    name: "Jens Engelfried",
    role: "Patient",
    image: images("./jens.png"),
    description: "we had an amazing experience with Luxury Golden Triangle on our 3 1/2 day trip from Delhi to Agra and Jaipur. From first contact months ago to pick-up at our Hotel in Delhi to a very early  ..."
  },
  {
    name: "Y G",
    role: "Local Guide",
    image: images("./yg.png"),
    description: "We had a wonderful 8-9 day trip in India with Luxury Golden Triangle Tour, visiting Agra, Jaipur, Udaipur, and ending in New Delhi. The itinerary was well arranged, and everything went ..."
  },
  {
    name: "Katerina fragkaki",
    role: "Patient",
    image: images("./katerina.png"),
    description: "We had a truly wonderful week in India with a full and well-structured program, staying in different hotels every two days and exploring various cities. The representitive of Luxury Golden ..."
  }
  ];
  return (
    <div className="testimonials mt-80">
      <div className="inner-testimonials">
        <div className="container">

          <div className="heading center">
            <h2>What Clients Say</h2>
            <p>Reviews/Testimonials</p>
          </div>

          <div className="testimonials-slider-main position-relative">

            <Slider {...settings} className="testimonials-slider">
  {testimonials456.map((item, index) => (
    <div
      key={index}
      className={`testimonials-slider-card ${
        index === activeSlide ? "active-center" : ""
      }`}
    >
      <img src={images("./inverted-comma.svg")} alt="quote" />

      {/* Description */}
      <p className="font-14 mb-3 heightsame">
        {item.description}
      </p>

      {/* ⭐ 5 Star Rating */}
      <div className="star-rating mb-3">
        {[...Array(5)].map((_, i) => (
          <span key={i} className="star">★</span>
        ))}
      </div>

      {/* User Image */}
      <img
        className="user-img"
        src={item.image}
        alt={item.name}
      />

      <h6>{item.name}</h6>
    </div>
  ))}
</Slider>

          </div>

        </div>
      </div>
    </div>
  );
}

export default Testimonials;